/* =====================================================================
   KOCKELÖREN RECEPTBANK – SHOPIFY-JS
   1) Portionväljare 1–4 personer (default 4) med smart skalning
      – läser JSON från fältet ingredients_structured.
   2) Sök + filterchips på bank- och kategorisidor
      – filtrerar receptkortens data-attribut.
   Ingen global kod utanför kock-namnrymden; påverkar inte mallen.
   ===================================================================== */
(function () {
  "use strict";

  /* ---------- Smart skalning (samma logik som prototypen) ---------- */
  var FRAC = { 0.25: "¼", 0.5: "½", 0.75: "¾" };
  function fmtNum(n) {
    var whole = Math.floor(n + 0.0001), rest = Math.round((n - whole) * 100) / 100;
    var fr = FRAC[rest];
    if (fr) return whole > 0 ? whole + " " + fr : fr;
    return String(Math.round(n * 100) / 100).replace(".", ",");
  }
  function roundTo(n, step) { return Math.round(n / step) * step; }

  function kockScale(ing, servings, base) {
    base = base || 4;
    if (ing.amount == null) return { amountText: "", noteOverride: ing.note || "efter smak" };
    var f = servings / base, a = ing.amount * f;
    var unit = ing.unit || "", name = (ing.name || "").toLowerCase();
    if (unit === "g") { a = a >= 500 ? roundTo(a, 25) : a >= 100 ? roundTo(a, 10) : roundTo(a, 5); if (a < 5) a = 5; return { amountText: fmtNum(a) + " g" }; }
    if (unit === "kg") { var g = a * 1000; if (g < 1000) return { amountText: fmtNum(roundTo(g, 25)) + " g" }; return { amountText: fmtNum(roundTo(a, 0.1)) + " kg" }; }
    if (unit === "l") { if (a < 1) return { amountText: fmtNum(roundTo(a * 10, 0.25)) + " dl" }; return { amountText: fmtNum(roundTo(a, 0.1)) + " l" }; }
    if (unit === "dl") { a = roundTo(a, 0.25); if (a < 0.25) a = 0.25; return { amountText: fmtNum(a) + " dl" }; }
    if (unit === "msk") { a = roundTo(a, 0.5); if (a < 0.5) return { amountText: "1 tsk" }; return { amountText: fmtNum(a) + " msk" }; }
    if (unit === "tsk") { a = roundTo(a, 0.5); if (a < 0.5) { var krm = roundTo(ing.amount * f * 5, 0.5) || 1; return { amountText: fmtNum(krm) + " krm" }; } return { amountText: fmtNum(a) + " tsk" }; }
    if (unit === "krm") { a = roundTo(a, 0.5); if (a < 0.5) a = 0.5; return { amountText: fmtNum(a) + " krm" }; }
    if (unit === "st" || unit === "port" || unit === "knippe" || unit === "blad") {
      var isEgg = name.indexOf("ägg") === 0 || name.indexOf("äggula") !== -1;
      a = roundTo(a, 0.5); if (a < 0.5) a = 0.5;
      if (isEgg && a === 0.5) return { amountText: "1 litet", noteOverride: "1 litet ägg räcker" };
      if (a === 0.5) return { amountText: "½" + (unit === "st" ? "" : " " + unit) };
      return { amountText: fmtNum(a) + (unit === "st" ? "" : " " + unit) };
    }
    return { amountText: fmtNum(roundTo(a, 0.25)) + (unit ? " " + unit : "") };
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  /* ---------- Portionväljare (plus/minus-stepper) ---------- */
  function initServingSelector() {
    var selector = document.querySelector("[data-kock-serving]");
    var jsonTag = document.querySelector("[data-kock-ingredients-json]");
    var target = document.querySelector("[data-kock-ingredients]");
    if (!selector || !jsonTag || !target) return;

    var ingredients;
    try { ingredients = JSON.parse(jsonTag.textContent); } catch (e) {
      console.warn("Kockelören: ingredients_structured är inte giltig JSON – reservlistan visas.", e);
      return;
    }
    var base = parseInt(selector.getAttribute("data-base"), 10) || 4;
    var MIN = 1, MAX = 20;
    var current = base;

    var numEl = selector.querySelector("[data-kock-servings-number]");
    var minusBtn = selector.querySelector("[data-kock-minus]");
    var plusBtn = selector.querySelector("[data-kock-plus]");

    function render(servings) {
      current = Math.max(MIN, Math.min(MAX, servings));
      if (numEl) numEl.textContent = current;
      if (minusBtn) minusBtn.disabled = current <= MIN;
      if (plusBtn) plusBtn.disabled = current >= MAX;
      var html = "<ul>";
      ingredients.forEach(function (ing) {
        if (ing.group) html += '<li class="kock-ingredient-group" style="border:none">' + esc(ing.group) + "</li>";
        var sc = kockScale(ing, current, base);
        html += '<li><span class="kock-amount">' + esc(sc.amountText || "") + "</span><span>" + esc(ing.name) +
          (sc.noteOverride ? " <em>(" + esc(sc.noteOverride) + ")</em>" : ing.note && ing.amount != null ? " <em>(" + esc(ing.note) + ")</em>" : "") +
          "</span></li>";
      });
      target.innerHTML = html + "</ul>";
    }

    if (minusBtn) minusBtn.addEventListener("click", function () { render(current - 1); });
    if (plusBtn) plusBtn.addEventListener("click", function () { render(current + 1); });

    render(base); // default 4 portioner
  }

  /* ---------- Sök & filter på bank/kategori ---------- */
  function initFilters() {
    var search = document.querySelector("[data-kock-search]");
    var bar = document.querySelector("[data-kock-filterbar]");
    var cards = document.querySelectorAll("[data-kock-card]");
    if (!cards.length || (!search && !bar)) return;

    var stateF = { q: "", difficulty: "", time: "", cookware: "", cuisine: "", chef: "", family: "" };

    function apply() {
      var visible = 0;
      var activePre = stateF.q || stateF.difficulty || stateF.time || stateF.cookware || stateF.cuisine || stateF.chef || stateF.family;
      var seen = {};
      cards.forEach(function (card) {
        var ok = true;
        if (stateF.q) {
          var hay = (card.getAttribute("data-search") || card.getAttribute("data-title") || "").toLowerCase();
          var terms = stateF.q.toLowerCase().split(/\s+/).filter(Boolean);
          for (var ti = 0; ti < terms.length; ti++) {
            var term = terms[ti], hit = hay.indexOf(term) !== -1;
            // Stamning: kapa ändelser så "grekiskt" träffar "grekiska", "franskt" -> "franska" osv.
            while (!hit && term.length > 5) { term = term.slice(0, -1); hit = hay.indexOf(term) !== -1; }
            if (!hit) { ok = false; break; }
          }
        }
        if (ok && stateF.difficulty && card.getAttribute("data-difficulty") !== stateF.difficulty) ok = false;
        if (ok && stateF.time && parseInt(card.getAttribute("data-time"), 10) > parseInt(stateF.time, 10)) ok = false;
        if (ok && stateF.cookware && card.getAttribute("data-cookware").indexOf(stateF.cookware) === -1) ok = false;
        if (ok && stateF.cuisine && (card.getAttribute("data-cuisine") || "").indexOf(stateF.cuisine) === -1) ok = false;
        if (ok && stateF.chef && card.getAttribute("data-chef") !== "1") ok = false;
        if (ok && stateF.family && card.getAttribute("data-family") !== "1") ok = false;
        // Extra-kort (bortom 8 per kategori) visas bara vid aktiv sökning/filter
        if (ok && !activePre && card.getAttribute("data-kock-extra") === "1") ok = false;
        // Vid aktiv sökning/filter: visa varje recept bara en gång (korten dubbleras mellan kategorisektioner)
        if (ok && activePre) {
          var t = card.getAttribute("data-title");
          if (seen[t]) ok = false; else seen[t] = true;
        }
        card.style.display = ok ? "" : "none";
        if (ok) visible++;
      });
      var count = document.querySelector("[data-kock-count]");
      var active = stateF.q || stateF.difficulty || stateF.time || stateF.cookware || stateF.cuisine || stateF.chef || stateF.family;
      if (count) count.textContent = active ? visible + " recept matchar" : "";
      // Dölj kategori-rutnätet när man söker/filtrerar så träffarna syns direkt
      var hub = document.querySelector("[data-kock-cathub]");
      if (hub) hub.style.display = active ? "none" : "";
      // Dölj kategorisektioner som blivit tomma
      document.querySelectorAll("[data-kock-catsection]").forEach(function (sec) {
        var any = Array.prototype.some.call(sec.querySelectorAll("[data-kock-card]"), function (c) { return c.style.display !== "none"; });
        sec.style.display = any ? "" : "none";
      });
    }

    if (search) search.addEventListener("input", function () { stateF.q = search.value; apply(); });
    if (bar) {
      bar.querySelectorAll(".kock-chip[data-kock-filter]").forEach(function (chip) {
        chip.addEventListener("click", function () {
          var key = chip.getAttribute("data-kock-filter"), val = chip.getAttribute("data-value");
          var active = chip.getAttribute("aria-pressed") === "true";
          bar.querySelectorAll('.kock-chip[data-kock-filter="' + key + '"]').forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
          if (!active) { chip.setAttribute("aria-pressed", "true"); stateF[key] = val; }
          else stateF[key] = "";
          apply();
        });
      });
      var reset = bar.querySelector("[data-kock-reset]");
      if (reset) reset.addEventListener("click", function () {
        stateF = { q: search ? search.value : "", difficulty: "", time: "", cookware: "", cuisine: "", chef: "", family: "" };
        bar.querySelectorAll(".kock-chip").forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
        apply();
      });
    }
    apply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initServingSelector(); initFilters(); });
  } else { initServingSelector(); initFilters(); }
})();